export function setGTMUserData(userData) {
    if(userData) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'user_data': {
                'first_name': userData.firstName || '',
                'last_name': userData.lastName || '',
                'email_address': userData.email || '',
                'phone_number': userData.phone || '',
            }
        });
    }
}
